import { render, staticRenderFns } from "./AirPollution.vue?vue&type=template&id=307cea58&scoped=true&"
import script from "./AirPollution.vue?vue&type=script&lang=js&"
export * from "./AirPollution.vue?vue&type=script&lang=js&"
import style0 from "./AirPollution.vue?vue&type=style&index=0&id=307cea58&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "307cea58",
  null
  
)

export default component.exports